module.exports = __webpack_public_path__ + "static/media/logo_text.c0eb4031.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/logo_text.svg
// module id = 222
// module chunks = 0